import { Record } from "immutable"

const AdditionalService = new Record({
  id: null,
  category: null, // TODO: Enum
  status: null,

  created: null, // timestamp
  updated: null, // timestamp // TODO: Check from additional bookings

  payment: null,
  params: null,
  assets: null, // check if needed

  description: null, // optional, booker's message
})

export default AdditionalService
